const initializePYEG = (root = document) => {
  root.querySelectorAll('.menu-toggle').forEach(toggle => {
    if (toggle.dataset.ready) return;
    toggle.dataset.ready = 'true';
    const nav = document.getElementById(toggle.getAttribute('aria-controls'));
    const close = () => { toggle.setAttribute('aria-expanded', 'false'); nav?.classList.remove('is-open'); };
    toggle.addEventListener('click', () => {
      const opened = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!opened));
      nav?.classList.toggle('is-open', !opened);
    });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
    nav?.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
  });
  root.querySelectorAll('[data-framework]').forEach(framework => {
    if (framework.dataset.ready) return;
    framework.dataset.ready = 'true';
    const tabs = Array.from(framework.querySelectorAll('[role="tab"]'));
    const activate = (tab, focus = false) => {
      tabs.forEach(item => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.setAttribute('tabindex', selected ? '0' : '-1');
        item.classList.toggle('is-active', selected);
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); activate(tabs[next], true);
      });
    });
  });
  root.querySelectorAll('[data-email-popup]').forEach(popup => {
    if (popup.dataset.ready) return;
    popup.dataset.ready = 'true';
    const dialog = popup.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const launcher = popup.querySelector('[data-popup-open]');
    const form = popup.querySelector('form');
    const result = popup.querySelector('[data-popup-result]');
    const storageKey = 'pyeg-email-popup-v1';
    let timer;
    let previousFocus;
    let dismissed = false;
    const readState = () => {
      try { return JSON.parse(localStorage.getItem(storageKey)) || {}; } catch { return {}; }
    };
    const writeState = update => {
      try { localStorage.setItem(storageKey, JSON.stringify({ ...readState(), ...update })); } catch {}
    };
    const open = () => {
      clearTimeout(timer);
      if (dialog.open) return;
      previousFocus = document.activeElement;
      dialog.showModal();
      (result || dialog.querySelector('h2')).focus();
    };
    const close = () => dialog.close();
    launcher.hidden = popup.dataset.subscribed === 'true' || readState().subscribed === true;
    launcher.addEventListener('click', open);
    popup.querySelectorAll('[data-popup-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    });
    dialog.addEventListener('close', () => {
      clearTimeout(timer);
      dismissed = true;
      writeState({ dismissedAt: Date.now() });
      if (previousFocus?.isConnected && previousFocus !== document.body) previousFocus.focus();
      else if (!launcher.hidden) launcher.focus();
    });
    const popupSubmitted = location.hash === `#${form.id}`;
    const anyNewsletterSuccess = Boolean(document.querySelector('.newsletter-form .form-success'));
    if (anyNewsletterSuccess) {
      writeState({ subscribed: true });
      launcher.hidden = true;
    }
    if (result && popupSubmitted) {
      open();
      return;
    }
    if (popup.dataset.designMode === 'true') {
      popup.closest('.shopify-section')?.addEventListener('shopify:section:select', open);
      return;
    }
    const canOpen = () => {
      const state = readState();
      const cooldown = Number(popup.dataset.repeatDays) * 86400000;
      return !dismissed && !state.subscribed && popup.dataset.subscribed !== 'true' && !anyNewsletterSuccess && (!state.dismissedAt || Date.now() - state.dismissedAt >= cooldown);
    };
    const autoOpen = () => {
      if (!popup.isConnected || !canOpen()) return;
      if (document.hidden || document.querySelector('dialog[open]') || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) {
        timer = setTimeout(autoOpen, 2000);
        return;
      }
      open();
    };
    if (canOpen()) timer = setTimeout(autoOpen, Number(popup.dataset.delay) * 1000);
  });
};
initializePYEG();
document.addEventListener('shopify:section:load', event => initializePYEG(event.target));
